import { useCallback, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderLayout from '../../../../components/Layout/Header/HeaderLayout';
import SimulatorResultPortfolio from '../../../../components/simulator/SimulatorResultPortfolio';
import Spinner from '../../../../components/Spinner';
import ModalErrorFetch from '../../../../components/UI/ModalErrorFetch';
import { InvestmentContext } from '../../../../context/InvestmentContext';
import useModal from '../../../../hooks/custom/useModal';
import { useGetModelsPortfolioById } from '../../../../hooks/useGetModelsPortfolioById';
import { useGetPorfolioSimulation } from '../../../../hooks/useGetPorfolioSimulation';
import { onRefresh } from '../../../../utils/refreshPage';

const PortfolioResult = ({}) => {
  const { id } = useParams();
  const [userNotOB, setUserNotOB] = useState(false);
  const navigate = useNavigate();
  const [localStorageLoaded, setLocalStorageLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useSelector(state => state.auth);

  const {
    formData,
    setSend,
    setFormData,
    dataSimulation,
    setDataSimulation,
    resetFormData,
    setDataSimulationResult,
  } = useContext(InvestmentContext);

  const { isShowing, toggle } = useModal();

  const {
    data: dataPortolioById,
    loading: loadingDataPortolioById,
    error: errorDataPortolioById,
  } = useGetModelsPortfolioById({
    modelId: id,
  });

  const {
    data: dataSimulationPortfolio,
    loading: isLoadingSimulation,
    error: errorSimulation,
    refetch,
  } = useGetPorfolioSimulation({
    data: dataSimulation,
  });

  const dataPortfolioSimulationById = dataPortolioById?.getModelById || [];

  const dataChart = dataPortfolioSimulationById[0] || {};

  const { profilePortfolio } = dataChart;

  const modelName =
    dataPortfolioSimulationById?.[0]?.code ||
    dataPortfolioSimulationById?.[0]?.name ||
    dataPortfolioSimulationById?.[0]?.fileAs ||
    null;

  const dataResultSimulation =
    dataSimulationPortfolio?.getPortfolioSimulation?.simulationData || [];

  const yearsToMonths = {
    '6 meses': 6,
    '1 año': 12,
    '2 años': 24,
    '3 años': 36,
    '5 años': 60,
  };

  const handleNavigate = () => {
    navigate('/portfolio');
  };

  const handleInvesment = () => {
    if (!userNotOB) {
      return navigate('/completeregistration');
    }
    if (userNotOB) {
      return navigate(`/simulator/portfolio/investment/${id}`);
    }
  };

  const handleSubmit = useCallback(
    async (values, riskPortfolio) => {
      if (isSubmitting) return;
      setIsSubmitting(true);

      try {
        localStorage.setItem('portfolioSimulationData', JSON.stringify(values));

        const effectivePortfolioName =
          (riskPortfolio && String(riskPortfolio).replace?.(/\sCLP$/, '')) ||
          (modelName && String(modelName).replace?.(/\sCLP$/, '')) ||
          'DefaultPortfolio';

        const payload = {
          ...values,
          initialInvestment: Number.parseInt(values.initialInvestment?.replace(/\D/g, '')),
          monthlyInvestment: Number.parseInt(values.monthlyInvestment?.replace(/\D/g, '')) || 0,
          months: yearsToMonths[values.months],
          portfolioName: effectivePortfolioName,
        };

        setFormData(values);
        setDataSimulation(payload);
        setSend(true);

        if (typeof refetch === 'function') {
          const res = await refetch({ data: payload });
          const simulationData = res?.data?.getPortfolioSimulation?.simulationData || [];

          setDataSimulationResult(
            Array.isArray(simulationData) && simulationData.length ? simulationData : [],
          );
        }
      } catch (err) {
        console.error('Error refetch:', err);
      } finally {
        setIsSubmitting(false);
      }
    },
    [
      isSubmitting,
      modelName,
      refetch,
      setDataSimulationResult,
      setDataSimulation,
      setFormData,
      setSend,
    ],
  );

  useEffect(() => {
    const savedData = localStorage.getItem('portfolioSimulationData');
    if (savedData) {
      const parsed = JSON.parse(savedData);
      setFormData(parsed);
      setDataSimulation({
        ...parsed,
        initialInvestment: Number.parseInt(parsed.initialInvestment?.replace(/\D/g, '')),
        monthlyInvestment: Number.parseInt(parsed.monthlyInvestment?.replace(/\D/g, '')) || 0,
        months: yearsToMonths[parsed.months],
        portfolioName: parsed?.portfolioName || modelName,
      });
    }
    setLocalStorageLoaded(true);
  }, [setFormData, setDataSimulation, modelName]);

  useEffect(() => {
    if (Array.isArray(dataResultSimulation) && dataResultSimulation.length) {
      setDataSimulationResult(dataResultSimulation);
    }
  }, [dataResultSimulation, setDataSimulationResult]);

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setUserNotOB(true);
    }
  }, [user]);

  if (loadingDataPortolioById) {
    return <Spinner />;
  }

  if (errorDataPortolioById || errorSimulation) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorDataPortolioById || errorSimulation}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }
  return (
    <>
      <HeaderLayout type='product' mode='portfolio' dataChart={dataChart} />

      {!localStorageLoaded || isLoadingSimulation ? (
        <Spinner />
      ) : (
        <SimulatorResultPortfolio
          formData={formData}
          handleSubmit={handleSubmit}
          riskPortfolio={profilePortfolio}
          resetFormData={resetFormData}
          handleNavigate={handleNavigate}
          handleInvesment={handleInvesment}
          dataResultSimulation={dataResultSimulation}
        />
      )}
    </>
  );
};

export default PortfolioResult;
